import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ModalMensaje } from 'src/app/models/ModalMensaje';
import { DatosGeneralComponent } from '../../datos-general/datos-general.component';
import { iconDescargar, RecupPartesFchInicio, NumIdParamRutaArchPlan, NumIdParamRutaArchGen, NumIdCatTipoPD, NumIdCatNombrPlantFW, NumIdCatDocGenFW, saveContent, isNumber, NumIdTipCatCampPlantFW, isNotEmpty, isNotEmptyList, CodTipoFichaFUR, CodSubTipoFichaOFI, cookieGlobalVars, GlobalVars, cambiarRouter } from 'src/app/general/variables';
import { ExternosService } from 'src/app/services/externos/externos.service';
import { PlantillaDocumento } from 'src/app/models/PlantillaDocumento';
import { NgxSpinnerService } from 'ngx-spinner';
import { ParametroService } from 'src/app/services/parametro.service';
import { CatalogoService } from 'src/app/services/Catalogo.service';
import { Fur } from 'src/app/models/Fur';
import { PDDatos } from 'src/app/models/PDDatos';
import { General } from 'src/app/models/General';
import { FurService } from 'src/app/services/fur.service';
import { DocumentoDet } from 'src/app/models/DocumentoDet';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';
import { Router } from '@angular/router';
import { FrmFURPorCodigoBorrador } from 'src/app/models/FrmFURPorCodigoBorrador';

@Component({
  selector: 'app-modal-guardar',
  templateUrl: './modal-guardar.component.html',
  styleUrls: ['./modal-guardar.component.css']
})
export class ModalGuardarComponent implements OnInit {

  strDsctitulo = '';
  strDscmensaje = '';
  strFchVencimiento = '';
  flgBorrador = false;
  strDscRutaArchivoPlant: string = null;
  strDscRutaArchivoGen: string = null;
  strDscNomArchivoGen: string = null;
  strDscNombrPlantilla: string = null;
  strDocumento: string = null;
  flgBase64: boolean = null;
  fur: Fur = null;
  FRegEx = new RegExp(/(?:this\.)(.+?(?= ))/g);
  pdDatos: PDDatos[] = [];
  data: ModalMensaje;

  iconDescargar = iconDescargar;

  @ViewChild(DatosGeneralComponent) DatosGeneralC: DatosGeneralComponent;
  // @ViewChild(NavModalComponent) navModalC : NavModalComponent;

  constructor(
    // public dialogRef: MatDialogRef<ModalGuardarComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: ModalMensaje,
    protected externosService: ExternosService,
    private spinner: NgxSpinnerService,
    protected parametroService: ParametroService,
    protected catalogoService: CatalogoService,
    protected furService: FurService,
    public router: Router

    ) { }

  ngOnInit() {

    let vPdDatos: PDDatos = new PDDatos();
    let furInput: Fur = null;


    cookieGlobalVars(6);

    this.data = GlobalVars.objetoRegExitoso;

    // let boolFlgRegExitoso:boolean = GlobalVars.FlgRegExitoso;

    // if(boolFlgRegExitoso == true)
    // {



    // }


    this.strDscmensaje = ''; //this.data.mensaje
    this.flgBorrador = false; //    this.flgBorrador = '';this.data.general.flgCampo1

    //furInput = this.data.fur;
    //this.strDocumento = this.data.general.dscCampo1;
   // this.flgBase64 = this.data.general.flgCampo2;


    // this.navModalC.setDatosNavModal2(this.strDsctitulo);

    /**this.strFchVencimiento = RecupPartesFchInicio(this.data.fur.strDfurFchrecep, 2);

    const frmFURPorCodigoBorrador: FrmFURPorCodigoBorrador = new FrmFURPorCodigoBorrador();

    frmFURPorCodigoBorrador.cfurCodborrador = furInput.cfurCodborrador;
    frmFURPorCodigoBorrador.cfurFecinicioreg = furInput.strDfurFecinicioreg.substring(0, 10);
    frmFURPorCodigoBorrador.cfurClavedenunc = furInput.cfurClavedenunc;*/

    // console.log("====this.frmFURPorCodigoBorrador.");
    // console.log(this.frmFURPorCodigoBorrador);

    /**this.furService.obtenerFurPorCodigoBorrador(frmFURPorCodigoBorrador).subscribe(
      data => {

        this.fur = data;

      });*/



    // this.furService.ObtenerFurPorId(furInput.nfurId).subscribe(data=>{

    //   this.fur = data;

    // });
/**
    this.parametroService.obtenerParametro(NumIdParamRutaArchPlan).subscribe(
      data => {

        this.strDscRutaArchivoPlant = data.cparamValor;

      });

    this.parametroService.obtenerParametro(NumIdParamRutaArchGen).subscribe(
      data => {

        this.strDscRutaArchivoGen = data.cparamValor;

      });

    this.catalogoService.listarCatalogo(NumIdCatTipoPD).subscribe(
      data => {

        this.strDscNombrPlantilla = data.find(x => x.ncatalogoId == NumIdCatNombrPlantFW).ccatalogoDsc;
        this.strDscNomArchivoGen = data.find(x => x.ncatalogoId == NumIdCatDocGenFW).ccatalogoDsc;

      });

    this.catalogoService.listarCatalogo(NumIdTipCatCampPlantFW ).subscribe(
      data => {

        data.forEach((element, index) => {

          index = index + 1;

          if ((index % 2)) {

            vPdDatos.nombre = element.ccatalogoDsc;

          } else {

            vPdDatos.campo = element.ccatalogoDsc;

            this.pdDatos.push(vPdDatos);

            vPdDatos = new PDDatos();

          }

        });

      });

    this.DatosGeneralC.setDatosGenerales(furInput);
*/

  }

  _regresar() {

    cambiarRouter(this.router, 3);

    // this.dialogRef.close(true);

  }

  _aceptar() {

    GlobalVars.objetoFurAcceda = this.fur;
    GlobalVars.FlgNuevoFw = false;

    cookieGlobalVars(3);

    cambiarRouter(this.router, 3);

    // this.dialogRef.close(false);

  }

  _descargaPdf2() {

    let vListaDoc: DocumentoDet[] = [];
    let vDocumentoUrl = '';

    if (this.flgBase64) {

      // saveContent(this.strDocumento, this.strDscNomArchivoGen);
      // saveContent(this.strDocumento, this.strDscNomArchivoGen);
      saveContent(this.strDocumento, 'Borrador_FormularioWeb.pdf');

    } else {

      // window.open("http://11.162.107.36/WebLink/0/doc/120241/Electronic.aspx", '_blank');

      vListaDoc = this.fur.listaDocumentoAdjuntoDet;

      if (isNotEmptyList(vListaDoc)) {

        vDocumentoUrl = vListaDoc.find(x => x.cdocumentoCodtipo == CodTipoFichaFUR && x.cdocumentoCodsubtipo == CodSubTipoFichaOFI).cdocumentoDscurl;

        window.open(vDocumentoUrl, '_blank');

      }

      // window.open(this.strDocumento, '_blank');

    }

  }



}
